<template>
  <f7-page name="inventory-list">
    <bc-navbar></bc-navbar>

    <div v-if='!isLoaded' class='loader-container' color="#f9f300">
      <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
    </div>

    <component v-else :is="inventoryComponentName" />

  </f7-page>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {
    InventoryProviderType
  } from '@/shared/enums/inventory.js'
import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
import InventoryVauto from '@/components/inventory/vauto-content.vue'
import InventoryDealerTrend from '@/components/inventory/dealertrend-content.vue'

export default {
  data () {
    return {
      isLoaded: false
    }
  },
  components: {
    'loader': LoopingRhombusesSpinner,
    InventoryVauto,
    InventoryDealerTrend
  },
  async mounted () {
    await this.getVehicalList()
    this.isLoaded = true
  },
  computed: {
    ...mapState({
      inventoryType: state => state.inventory.providerType
    }),
    inventoryComponentName () {
      if (!this.inventoryType) {
        return null
      }
      return this.inventoryType === InventoryProviderType.Vauto || this.inventoryType === InventoryProviderType.OfferLogix
        ? 'InventoryVauto' : 'InventoryDealerTrend'
    }
  },
  methods: {
    ...mapActions({
      getVehicalList: 'inventory/loadVehicalList'
    })
  }
}
</script>

<style scoped>
  .loader-container {
    width: 100%;
    text-align: center;
    padding-top: 15%;
  }

  .looping-rhombuses-spinner {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// inventory.vue?48172658